import tenantTheme from '@theme';
import styled from 'styled-components';
import Group from '../../common/group/group';
import { Thumbnail } from '../../common/image-uploads/styled';
import { v2Color } from '@theme/v2';

export const VideoSelector = styled.div`
  position: relative;

  .ant-checkbox {
    border-radius: 4px;
    position: absolute;
    inset-block-start: 8px;
    inset-inline-start: 8px;

    + span {
      border-radius: ${tenantTheme['border-radius-base']};
      overflow: hidden;
      padding-inline: initial;
      display: inline-block;
      width: inherit;
      height: inherit;
    }
  }

  .ant-checkbox-checked {
    + span {
      box-shadow: 0 0 0 2px ${tenantTheme['primary-color']};
    }
  }

  ${Thumbnail} {
  }
`;

export const AddVideo = styled(Group)`
  border: 1px dashed ${tenantTheme['primary-color']};
  border-radius: ${tenantTheme['border-radius-base']};
  padding: 16px;
  position: relative;

  .btn-close {
    position: absolute;
    inset-block-start: 10px;
    inset-inline-end: 8px;
    top: -5px;
    right: 0px;
  }
`;

/* Bayut redesign — "Add Videos of your Property" (Figma LP-5096). */
export const VideoTitle = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 600;
  line-height: 21.99px;
  margin: 0;
`;

export const VideoDesc = styled.p`
  color: #9d9d9d;
  font-size: 14px;
  line-height: 21.99px;
  margin: 0;
`;

/* The light-teal rounded container around each link row (and its preview). */
export const VideoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  min-width: 0;
  padding: 12px 16px;
  border-radius: 6px;
  background: ${v2Color('#f2fafa')};
`;

export const VideoInputLine = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
`;

export const VideoInputBox = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 13px 12px 14px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  background: #fff;

  input {
    width: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    color: #222;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
  }
  input::placeholder {
    color: ${tenantTheme['placeholder-color']};
    font-weight: 500;
  }
`;

export const DeleteVideoBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  /* Match the URL input's height so the cross box aligns with the field. */
  align-self: stretch;
  min-height: 44px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${({ $filled }) => ($filled ? '#FDD6D6' : '#F0F0F0')};
  background: ${({ $filled }) => ($filled ? '#FFF1EE' : '#FFF')};
`;

export const VideoPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  /* Align the preview with the URL input above (past the 17px YouTube glyph + 12px gap). */
  margin-inline-start: 29px;

  img {
    flex-shrink: 0;
    width: 80px;
    height: 60px;
    border-radius: 6px;
    object-fit: cover;
    background: ${v2Color('#e9eef0')};
  }
  .meta {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }
  .title {
    color: #222;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .channel {
    color: #626262;
    font-size: 12px;
    margin: 0;
  }
`;
